(function () {
  var blocks = document.querySelectorAll('.product-feature-block');

  if (!blocks.length) {
    return;
  }

  blocks.forEach((block) => {
    productFeatureSlider(block);
  });

  function productFeatureSlider(block) {
    var slideIndex = 0;
    var slides = block.querySelectorAll('.product-feature-block__image-row');
    var titles = block.querySelectorAll('.product-feature-block__title-row');
    var counter = block.querySelector('[data-slide-current]');
    var btnPrev = block.querySelector('[data-slide-left]');
    var btnNext = block.querySelector('[data-slide-right]');

    if (!slides.length) {
      return;
    }

    function prevSlide() {
      slideIndex = (slideIndex - 1 + slides.length) % slides.length;
      showSlide(slideIndex);
      updateCount();
    }

    function nextSlide() {
      slideIndex = (slideIndex + 1) % slides.length;
      showSlide(slideIndex);
      updateCount();
    }

    function showSlide(n) {
      slides.forEach(function (slide, i) {
        slide.classList.toggle(
          'product-feature-block__image-row--active',
          i === n
        );
      });
      titles.forEach(function (title, i) {
        title.classList.toggle(
          'product-feature-block__title-row--active',
          i === n
        );
      });
    }

    function updateCount() {
      if (!counter) {
        return;
      }
      var current = String(slideIndex + 1).padStart(2, '0');
      var total = String(slides.length).padStart(2, '0');
      var display = `${current}/${total}`;
      counter.textContent = display;
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', prevSlide);
    }

    if (btnNext) {
      btnNext.addEventListener('click', nextSlide);
    }
  }
})();
